import src from "IMAGE";
export default { src, width: 11, height: 16, blurWidth: 0, blurHeight: 0};
